<svg>
  <svg:use
    attr.xlink:href="/assets/svg/goodLoadingIcons6.svg#{{ name }}"
    attr.href="/assets/svg/goodLoadingIcons6.svg#{{ name }}"
  ></svg:use>
</svg>
